import React from 'react';
import { Flame, Shield, Brain, Heart, Users, Target } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Flame,
  Shield,
  Brain,
  Heart,
  Users,
  Target
};

const Benefits = () => {
  return (
    <section className="py-24 bg-bg-page relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/5 via-transparent to-brand-primary/5"></div>
      <div className="absolute top-20 right-20 w-96 h-96 bg-brand-primary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-brand-primary/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-white mb-6">
            Transformação Real
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Mais do que treinar. Aqui você evolui corpo, mente e confiança.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const Icon = iconMap[benefit.icon];
            const getBenefitBg = (title) => {
              const t = title.toLowerCase();
              if (t.includes('físico')) return 'muay_thai_silhouette_bg_1774631485469.png';
              if (t.includes('autoconfiança')) return 'jiujitsu_roll_subtle_bg_1774631500408.png';
              if (t.includes('disciplina mental')) return 'martial_arts_hero_premium_1774630170837.png';
              if (t.includes('estresse')) return 'boxing_bag_subtle_bg_1774631516829.png';
              if (t.includes('comunidade')) return 'welcoming_gym_community_bg_1774631532611.png';
              return 'safe_training_pads_bg_1774631606275.png';
            };

            return (
              <div
                key={benefit.id}
                className="relative p-8 glass-card border-white/5 rounded-2xl hover:border-brand-primary group overflow-hidden"
              >
                {/* Unique Benefit Background Image */}
                <div 
                  className="absolute inset-0 opacity-20 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center grayscale"
                  style={{ backgroundImage: `url('${getBenefitBg(benefit.title)}')` }}
                ></div>

                {/* Animated Background Glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Large Icon with Glow Effect */}
                <div className="relative mb-6">
                  <div className="w-20 h-20 bg-gradient-to-br from-brand-primary to-red-700 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-2xl shadow-brand-primary/50">
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                  {/* Glow ring */}
                  <div className="absolute inset-0 w-20 h-20 bg-brand-primary/30 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-black text-white mb-4 relative z-10 group-hover:text-brand-primary transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-base text-gray-400 leading-relaxed relative z-10">
                  {benefit.description}
                </p>

                {/* Corner Accent */}
                <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-brand-primary/20 rounded-full blur-2xl"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
